// 3rd party libs
import React from 'react';

// Components
import { Typography } from 'components';
import { FlyoutNavItem, List, NavItem, NavWrapper } from './TabNav.element';
import theme from 'themes';
import { Tab } from 'types/maintenance';

export interface TabNavItem {
  label: string;
  active?: boolean;
  isTabEnabled: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
  subTabs?: Tab[];
}

interface Props {
  items: TabNavItem[];
  isFlyoutNav?: boolean;
}

const TabNav = ({ items, isFlyoutNav = true }: Props): JSX.Element => {
  return (
    <nav>
      <List>
        {items.map((item, index) =>
          isFlyoutNav ? (
            <FlyoutNavItem
              isTabEnabled={item.isTabEnabled === false || undefined ? false : true}
              active={item.active}
              onClick={item.isTabEnabled === false || undefined ? undefined : item.onClick}
              key={item.label}
            >
              <NavWrapper>
                {item?.icon
                  ? React.cloneElement(item.icon as React.ReactElement, {
                      color:
                        item.isTabEnabled === false
                          ? theme.colors.tableborder
                          : item.active
                          ? theme.colors.primaryBlue5
                          : theme.colors.lightGrey8
                    })
                  : null}
                <Typography
                  as="span"
                  weight="bold"
                  size={'clamp(12px, 1.7vw, 15px)'}
                  mb={0}
                  color={item.active ? theme.colors.primaryBlue5 : theme.colors.lightGrey8}
                >
                  {item.label}
                </Typography>
              </NavWrapper>
              {items.length === index + 1 ? null : <div className="divider" />}
            </FlyoutNavItem>
          ) : (
            <NavItem
              active={item.active}
              isTabEnabled={item.isTabEnabled}
              onClick={item.isTabEnabled ? item.onClick : undefined}
              key={item.label}
            >
              <Typography
                as="span"
                weight="bold"
                mb={0}
                color={item.active ? 'primaryBlue5' : 'darkGrey'}
              >
                {item.label}
              </Typography>
            </NavItem>
          )
        )}
      </List>
    </nav>
  );
};

export default TabNav;
